import { render } from "./Courseitem.vue?vue&type=template&id=495df400&scoped=true"
import script from "./Courseitem.vue?vue&type=script&lang=js"
export * from "./Courseitem.vue?vue&type=script&lang=js"

import "./Courseitem.vue?vue&type=style&index=0&id=495df400&scoped=true&lang=css"

import exportComponent from "C:\\Users\\satish\\Desktop\\WEBDEV\\assignment\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495df400"]])

export default __exports__